// Canonical Field Status values, mirroring core DropdownStatusComponent's default
// list. Introduced for NK-207 so the schedule auto-complete picker shares one source
// instead of hardcoding its own copy. Other hardcoded copies across the workspace can
// be converged onto this constant under a separate tech-debt ticket.
export const FIELD_STATUSES = ['Test', 'Soft Launch', 'Full Launch', 'Paused', 'Closed', 'Invoiced'];

// Field Status values available for an instance. 'Invoiced' is hidden for OR instances.
export function getFieldStatuses(isORInstance: boolean): string[] {
  return isORInstance ? FIELD_STATUSES.filter(s => s !== 'Invoiced') : [...FIELD_STATUSES];
}
